<template>
    <div class="space-y-4">
        <label class="flex items-start">
            <input
                type="checkbox"
                v-model="enable2fa"
                value="1"
                class="form-checkbox"
            />
            <span
                class="flex flex-col gap-1 ml-2 text-sm text-slate-800 leading-tight"
            >
                <span>Enable Two Factor Authentication (2FA)</span>

                <span class="text-sm text-slate-500">
                    You can also do this later from your account settings
                </span>
            </span>
        </label>

        <label class="flex items-start">
            <input
                type="checkbox"
                v-model="agreeToTerms"
                value="1"
                class="form-checkbox"
            />
            <span
                class="flex flex-col gap-1 ml-2 text-sm text-slate-800 leading-tight"
            >
                <span class="text-slate-800">
                    I agree to the
                    <a href="/terms-of-use" class="link" target="_blank">
                        Terms of Service
                    </a>
                    and
                    <a href="/privacy-policy" class="link" target="_blank">
                        Privacy Policy
                    </a>
                    .
                </span>
                <span class="text-sm text-slate-500">
                    You may opt out of email notifications at any time.
                </span>
            </span>
        </label>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useRegisterStore } from '@/store/register';

const registerStore = useRegisterStore();
const { agreeToTerms, enable2fa, registerCreds } = storeToRefs(registerStore);
</script>
